import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralASError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { ReferenceRate } from 'src/features/referenceRates/utils/types';
import { PatchReferenceRateFormSchemaValues } from 'src/features/referenceRates/utils/formSchema';

const RESOURCE = '/subscriptions/reference-rate/:id/';

type MutationFnType = typeof mutationFn;

interface DTO extends PatchReferenceRateFormSchemaValues {
    id: string;
}

// PATCH rather than PUT so an untouched currency is never resent - the backend rejects a currency
// change once pricing policies index the rate.
const mutationFn = ({ id, ...data }: DTO): Promise<ReferenceRate> => {
    return axios.patch(formatResourcePath(RESOURCE, { id }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as usePatchReferenceRate };
